import React from 'react';

const MusicVideo: React.FC = () => null;

export default MusicVideo;
